// @flow

import * as React from 'react';
import { Base, Interactive, Svg } from '@gandi/ui';

import styles from './DocumentationGuide.scss';

type Props = {|
  icon: string,
  title: string,
  description: string,
  href: string,
|};

function DocumentationGuide({
  icon,
  title,
  description,
  href,
}: Props): React.Element<typeof Interactive> {
  return (
    <Interactive
      flex
      flexGrow1
      href={href}
      hoverable
      bordered
      borderColor="white"
      hoverBorderColor="green-dark"
      backgroundColor="white"
      className={styles.container}
    >
      <Base
        flex
        flexRow
        padding="base"
        tagName="section"
        className={styles.wrapper}
      >
        <Base flex flexAlignItemsCenter marginRight="small">
          <Svg name={icon} theme="green" />
        </Base>

        <Base flex flexCol flexGrow1 flexJustifyCenter color="base">
          <Base tagName="h2" size="base" marginBottom="xsmall">
            {title}
          </Base>

          <Base tagName="p" weight="regular" margin="none">
            {description}
          </Base>
        </Base>
      </Base>
    </Interactive>
  );
}

export default DocumentationGuide;
